import Cookie from '@/services/cookie';
import store from '@/apps/apply/store';

export default {
    async getMe(to, from, next) {
        const token = Cookie.getToken();
        const redirectToLogin = `/user-login?redirect=${window.location.pathname}`;
        if (token) {
            if (!store?.state?.user?.id) {
                let valid = true;
                await store.dispatch('me/getMe').catch(() => {
                    Cookie.deleteToken();
                    valid = false;
                });

                if(!valid){
                    window.location.href = redirectToLogin;
                    return;
                }
            }
        }
        next();
    },
};
